import { useMemo } from 'react';
import { useAppSelector } from '@/store/hooks';
import { selectCampaignTemplates } from '@/store/slices/campaign-templates/selectors';

export const useFilteredTemplates = (category?: string) => {
  const templates = useAppSelector(selectCampaignTemplates);

  return useMemo(() => {
    if (!category || category === 'all') return templates;
    return templates.filter((t) => t.category === category);
  }, [templates, category]);
};
